module.exports = __WEBPACK_EXTERNAL_MODULE_189__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 189
// module chunks = 0